import { jsxs, jsx } from "react/jsx-runtime";
import { event } from "@zillow/universal-analytics";
import { yieldCallback } from "@zillow/yield-callback";
import { usePageProps, withPreload, getCmsInfoForPage, CardImage, ColorCard } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import styled from "styled-components";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
import { withTrigger } from "../../util/helpers.esm.js";
import { populateParamPlaceholders } from "../../util/populateParamPlaceholders.esm.js";
const CardImagePreload = withPreload(CardImage);
const BlockCard = ({
  attrs,
  index,
  innerBlocks
}) => {
  const pageProps = usePageProps();
  const {
    textAlign = "inherit",
    cardImage = {},
    loading = "lazy",
    cardElevation = 1,
    cardDirection = "bottom",
    link,
    backgroundColor,
    fontColor = "textDark",
    appearance = "default",
    padding = {
      paddingTop: {
        default: "sm"
      },
      paddingBottom: {
        default: "sm"
      },
      paddingRight: {
        default: "sm"
      },
      paddingLeft: {
        default: "sm"
      }
    },
    id,
    ...rest
  } = attrs;
  return /* @__PURE__ */ jsxs(StyledCardWithTrigger, { id, style: {
    textAlign
  }, appearance, cardDirection, cardElevation, backgroundColor, fontColor, interactive: (link == null ? void 0 : link.url) ? true : void 0, triggerLink: (link == null ? void 0 : link.url) || link, onMouseEnter: (e) => {
    event({
      // https://dataportal.zillowgroup.net/event-registry/2049
      envelope: {
        event_type_id: "2049",
        event_type_version_id: "1",
        event_template_id: "126",
        event_template_version_id: "1"
        // Master ID: 2284.2.126.1
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_card",
        trigger_object_nm: "no_trigger_object"
      },
      semantic: {
        semantic_event_nm: "cms_hover"
      },
      cms_info: {
        block_id: id || "",
        block_type_cd: "card",
        block_displayed_txt: e.target.textContent,
        block_target_url: (link == null ? void 0 : link.url) || "",
        block_target_window_txt: (link == null ? void 0 : link.opensInNewTab) ? "_blank" : "",
        ...getCmsInfoForPage(pageProps)
      }
    });
  }, onClick: yieldCallback((e) => {
    if (!(link == null ? void 0 : link.url)) return;
    const url = populateParamPlaceholders(link.url);
    event({
      // https://dataportal.zillowgroup.net/event-registry/2048
      envelope: {
        event_type_id: "2048",
        event_type_version_id: "1",
        event_template_id: "126",
        event_template_version_id: "1"
        // Master ID: 2284.2.126.1
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_card",
        trigger_object_nm: "no_trigger_object"
      },
      semantic: {
        semantic_event_nm: "cms_click"
      },
      cms_info: {
        block_id: id || "",
        block_type_cd: "card",
        block_displayed_txt: e.target.textContent,
        block_target_url: url,
        block_target_window_txt: link.opensInNewTab ? "_blank" : "",
        ...getCmsInfoForPage(pageProps)
      }
    });
    if (link.opensInNewTab) {
      window.open(url);
    } else {
      window.location.href = url;
    }
  }), ...padding, ...rest, children: [
    cardImage.src && /* @__PURE__ */ jsx(CardImagePreload, { ...cardImage, loading, decoding: cardImage.decoding || "async" }),
    generateBlockList({
      blocks: innerBlocks
    })
  ] }, index);
};
BlockCard.propTypes = {
  attrs: PropTypes.shape({
    id: PropTypes.string,
    textAlign: PropTypes.string,
    cardImage: PropTypes.shape(CardImage.propTypes),
    loading: PropTypes.string,
    cardElevation: PropTypes.oneOf([0, 1]),
    cardDirection: PropTypes.oneOf(["bottom", "top", "left", "right"])
  }),
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
};
const StyledCard = /* @__PURE__ */ styled(ColorCard).withConfig({
  displayName: "Card__StyledCard",
  componentId: "sc-17txm87-0"
})(["height:100%;max-width:100%;"]);
const StyledCardWithTrigger = withTrigger(StyledCard);
export {
  BlockCard as default
};
